// ═══════════════════════════════════════════════════════════════════════════
// AUREUS — QUELLE LANGUE AFFICHER À L'ARRIVÉE (logique PURE, testée)
// ───────────────────────────────────────────────────────────────────────────
// Mesuré le 29/08/2026 : `/pricing` EST traduit — son dictionnaire porte 76
// lignes de néerlandais, autant que le français. Mais il démarre sur
// `useState('fr')` sans jamais regarder d'où vient le visiteur. Un employeur
// néerlandophone qui arrive d'une des 232 pages NL tombe donc sur du français
// et doit trouver un petit bouton « NL » dans la barre du haut.
//
// ⚠️ CE MODULE EST NÉ D'UNE ERREUR DE MESURE, ET C'EST LA LEÇON À GARDER.
// J'avais conclu « /pricing n'est pas traduit » en comptant les
// `lang === 'nl'` ÉCRITS DANS LE CORPS de la page : il y en a 3. Le vrai
// contenu est dans le dictionnaire `T`, que ce motif ne voyait pas. Des octets
// reçus plus un motif suspect donnent une conclusion fausse (R2 ter) — et
// celle-ci a failli faire retirer un lien légitime, puis écrire au fondateur
// qu'il fallait traduire une page qui l'est déjà.
//
// Ordre de priorité, du plus explicite au plus faible :
//   1. `?lang=nl` dans l'URL — le visiteur (ou le lien qui l'amène) l'a demandé
//   2. le dernier choix retenu du visiteur
//   3. le défaut du site
// Verrou : __tests__/langue-arrivee.test.js
// ═══════════════════════════════════════════════════════════════════════════

/**
 * @param {object} p
 * @param {string} [p.recherche] la query string (`window.location.search`)
 * @param {string|null} [p.memorisee] le dernier choix retenu
 * @param {string[]} [p.disponibles] langues réellement servies par la page
 * @param {string} [p.defaut]
 */
export function langueArrivee({ recherche = '', memorisee = null, disponibles = ['fr', 'nl'], defaut = 'fr' } = {}) {
  const ok = (l) => typeof l === 'string' && disponibles.includes(l.toLowerCase());

  let demandee = null;
  try {
    // `URLSearchParams` accepte la chaîne avec ou sans « ? ».
    demandee = new URLSearchParams(String(recherche || '')).get('lang');
  } catch { demandee = null; }
  if (ok(demandee)) return demandee.toLowerCase();

  if (ok(memorisee)) return memorisee.toLowerCase();
  return disponibles.includes(defaut) ? defaut : disponibles[0];
}


// ═══════════════════════════════════════════════════════════════════════════
// LA LANGUE CHOISIE SE RETIENT — une seule définition, pour quatre pages
// ───────────────────────────────────────────────────────────────────────────
// ⚠️ CES DEUX FONCTIONS VIVAIENT EN LOCAL DANS /pricing (29/08/2026). Le
// 02/09, les trois pages légales en ont eu besoin à leur tour : les recopier
// aurait fait QUATRE définitions de la même clé de stockage, donc quatre
// occasions de diverger sur son nom — et une clé qui diverge, c'est un choix
// de langue qui disparaît sans que rien ne casse.
//
// 🔐 R10 — ce qui est stocké : la langue d'une page PUBLIQUE, rien d'autre.
// Aucune donnée métier, aucune donnée personnelle. Le préfixe `aureus_lang`
// est déjà audité côté reducer.
export const CLE_LANGUE = 'aureus_lang_pricing';

/** Le dernier choix de langue, ou `null` si le stockage est refusé. */
export const lireLangueRetenue = () => {
  try { return window.localStorage.getItem(CLE_LANGUE); } catch { return null; }
};

/** Retient le choix. Un stockage refusé est sans effet, jamais une erreur. */
export const retenirLangue = (l) => {
  try { window.localStorage.setItem(CLE_LANGUE, l); } catch { /* stockage refusé : sans effet */ }
};
